import { CloudStorage } from 'react-native-cloud-storage';
import DeviceInfo from 'react-native-device-info';

import {
    getDeviceId,
    toLog
} from '../Backup';
import {
    getFileFromCloud,
    ICLOUD_SCOPE
} from './iCloudFiles';

/**
 * Get devices data from iCloud.
 * This function retrieves the devices data stored in a JSON file from iCloud - devices.json.
 * If the file does not exist or cannot be parsed, it returns an empty object.
 * @returns {Promise<{}|any>}
 */
export const getDevicesData = async () => {
    const data = await getFileFromCloud({
        fileName: 'devices.json',
        withData: true,
        defaultData: '{}',
        timeout: 500,
        attempts: 20,
    });
    try {
        return JSON.parse(data?.data || '{}');
    } catch (e) {
        toLog('ICloud getDevicesData: error parsing devices data', {
            e,
            data,
        });
        return {};
    }
};

/**
 *
 * @returns {Promise<void>}
 * @param deviceData<{deviceId: string, deviceName: string, deviceName: string}>
 */
export const setDeviceData = async (deviceData) => {
    const data = await getDevicesData();
    data[deviceData.deviceId] = deviceData;
    await CloudStorage.writeFile('devices.json', JSON.stringify(data), ICLOUD_SCOPE);
};

/**
 * Set devices data in iCloud.
 * This function updates the devices data by adding the current device's information
 * (device ID, device name, and device model) to the existing data in devices.json.
 * If the devices.json file does not exist, it creates a new one with the current device's data.
 * @returns {Promise<void>}
 */
export const setDevicesData = async () => {
    const deviceData = {
        deviceId: await getDeviceId(),
        deviceName: DeviceInfo.getDeviceNameSync(),
        deviceModel: DeviceInfo.getModel(),
    };
    await setDeviceData(deviceData);

};

